import jQuery from 'jquery';
import { getURLDomain } from '@shared/url';
import { cookieBase, cookieDomain } from 'server-data/flconfigs';

export function setCookie(cName, value, expiredays, expiremins = 0) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie =
    `${cName}=${value}` +
    `${expiredays == null ? '' : `;expires=${exdate.toUTCString()}`}` +
    '; path=/; secure';
}

export function setArrayCookie(cName, value, expiredays) {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  setCookie(cName, value, expiredays);
}

export function setCookieToBrowser(
  cookieName,
  cookieValue,
  expiredays,
  path,
  domain,
) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    `${cookieName}=${escape(cookieValue)}` +
    `${exdate ? `;expires=${exdate.toUTCString()}` : ''}` +
    `${path ? `;path=${path}` : ''}` +
    `${domain ? `;domain=${domain}` : ''}` +
    `${';secure'}`;
}

export function getCookie(cName) {
  const cookies = document.cookie;
  if (cookies.length > 0) {
    let cStart = cookies.indexOf(`${cName}=`);
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      let cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

export function getArrayCookie(cName) {
  const fromCookie = getCookie(cName);
  if (fromCookie) {
    return JSON.parse(fromCookie);
  }

  return [];
}

export function getCookieNameLikes(partName) {
  if (document.cookie.length > 0) {
    const cookieNameArr = [];
    let nameStart = document.cookie.indexOf(partName, 0);
    while (nameStart != -1) {
      const nameEnd = document.cookie.indexOf(
        '=',
        nameStart + partName.length + 1,
      );
      if (nameEnd == -1) {
        break;
      }
      cookieNameArr.push(
        document.cookie
          .substring(nameStart, nameEnd)
          .replace('_savedsearch_', ''),
      );
      nameStart = document.cookie.indexOf(partName, nameEnd);
    }
    return cookieNameArr;
  }
  return '';
}

export function getCookies(partName) {
  const namesArr = getCookieNameLikes(partName);
  let i;
  const cookiesArr = [];
  for (i = 0; i < namesArr.length; i++) {
    const cookie = {};
    cookie.name = namesArr[i];
    cookie.value = getCookie(namesArr[i]);
    cookiesArr.push(cookie);
  }
  return cookiesArr;
}

export function getUserIdfromCookie() {
  return getCookie(`${cookieBase}_USER_ID`);
}

// Checks if the referring URL is an external domain
function isReferrerExternal(forCookie) {
  if (typeof forCookie === 'undefined') {
    forCookie = false;
  }

  const referrer = document.referrer;
  const referrerDomain = getURLDomain(document.referrer);
  if (referrer != null && referrer != '' && referrerDomain != document.domain) {
    // parse alternate domains from the <link> objects in the head
    const domains = jQuery('link[rel^="alternate"]').map(function() {
      return getURLDomain(jQuery(this).attr('href'));
    });

    // check current referrer
    for (let i = 0; i < domains.length; i++) {
      if (referrerDomain == domains[i]) {
        return false;
      }
    }

    return true;
  } else if (referrer === '' && !forCookie) {
    return true;
  }

  return false;
}

export function setReferralCookie() {
  const referrer = document.referrer;

  // parse alternate domains from the <link> objects in the head
  const domains = jQuery('link[rel^="alternate"]').map(function() {
    return getURLDomain(jQuery(this).attr('href'));
  });

  // remove domains
  for (let i = 0; i < domains.length; i++) {
    // if cookie is already set
    if (getCookie(`${cookieBase}_REFERRAL_URL`) != '') {
      // cookie = freelancer domain
      if (
        getURLDomain(getCookie(`${cookieBase}_REFERRAL_URL`)) === domains[i]
      ) {
        // set expiry negative
        setCookieToBrowser(
          `${cookieBase}_REFERRAL_URL`,
          referrer,
          -45,
          '/',
          cookieDomain,
        );
      }
    }
  }
  if (isReferrerExternal(true)) {
    setCookieToBrowser(
      `${cookieBase}_REFERRAL_URL`,
      referrer,
      365,
      '/',
      cookieDomain,
    );
  }
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

export function getAuthHeader() {
  const authHashV2 = getCookie(`${cookieBase}_AUTH_HASH_V2`);
  const userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': `${userId};${authHashV2}` };
}

function randomString(length, chars) {
  let result = '';
  for (let i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

export function getCSRFToken() {
  let token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(
      64,
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
    );
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}
